module.exports = __webpack_public_path__ + "media/images/emblems/Sarnen-coat_of_arms-7d044045cf6d6cbe325bd6a55f86d7ee.svg";